import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=e8715666"
import script from "./EmptyList.vue?vue&type=script&lang=ts"
export * from "./EmptyList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports